import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './AuthPages.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API_BASE}/auth/verify-email?token=${encodeURIComponent(token)}`);
        const data = await res.json();
        if (res.ok && data.success) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully!');
        } else {
          setStatus('error');
          setMessage(data.detail || data.error || 'Verification failed.');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Network error. Please try again.');
      }
    })();
  }, [searchParams]);

  return (
    <div className="ap-root">
      <div className="ap-card">
        {status === 'verifying' && (
          <>
            <div className="ap-icon">⏳</div>
            <h1 className="ap-title">Verifying your email…</h1>
            <p className="ap-subtitle">Please wait a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="ap-icon">✅</div>
            <h1 className="ap-title">Email Verified!</h1>
            <p className="ap-subtitle">{message}</p>
            <button className="ap-btn" onClick={() => navigate('/')}>
              Continue to Heart Felt Souls
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="ap-icon">❌</div>
            <h1 className="ap-title">Verification Failed</h1>
            <p className="ap-subtitle ap-error">{message}</p>
            <button className="ap-btn" onClick={() => navigate('/')}>
              Back to Home
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
